<!--  -->
<template>
  <div class="shell">
    <div class="sourceContainer">
      <div class="sourceTop">
        <div class="desc">
          <p>
            如果在其他地方引用了资源库图片，则删除资源库图片后，图片将失效无法显示。
          </p>
          <p class="record">共有{{ total }}条记录</p>
        </div>
        <div class="btns">
          <el-upload
            accept="image/jpeg,image/gif,image/png"
            action="https://www.58zltc.com/wechat/agent.image/upload"
            :show-file-list="false"
            :on-success="handleLogoSuccess"
            :before-upload="beforeLogoUpload"
            :data="imageData"
            name="image"
          >
            <el-button size="small" type="success">上传</el-button>
          </el-upload>
          <el-dropdown @command="delImg">
            <el-button size="small">删除</el-button>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="all">删除全部</el-dropdown-item>
              <el-dropdown-item command="single">删除选中</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <ul class="sourceList" v-if="dataList.length">
        <li
          v-for="(item, index) in dataList"
          :key="index"
          @click="choseFun(item)"
        >
          <div class="imgBox ">
            <img
              :src="item.url"
              class="img"
              width="170"
              height="170"
              style="display: block;"
            />
            <div class="noCheck" v-if="choseImg == item.id">
              <img src="@public/img/checkImg.png" alt="" />
            </div>
          </div>
          <p class="fileName ellipsis">创建时间：{{ item.createTime }}</p>
        </li>
      </ul>
      <div class="null" v-else>空空如也~</div>
      <div class="page">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import time from "@/utils/time";
import { mapGetters } from "vuex";
import { materialDel, materialList } from "@/api/push";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  inject: ["reload"],
  data() {
    return {
      page: 1,
      total: 0,
      imageData: {},
      dataList: [],
      choseImg: ""
    };
  },

  components: {},
  created() {
    this.imageData = {
      token: this.token,
      app_id: this.app_id
    };
    this.getList();
  },
  methods: {
    delImg(value) {
      console.log("单个删除", value);
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      if (value == "single") {
        if (this.choseImg == "")
          return this.$message.warning("请先选择一张图片！！");
        data.image_id = this.choseImg;

        materialDel(data).then(res => {
          if (res.code == 200) {
            this.$message.success("删除成功！！");
            this.reload();
          } else {
            this.$message.warning(res.msg);
          }
          console.log(res);
        });
      } else {
        this.$confirm("确定要删除全部图片?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        })
          .then(() => {
            // 选中类型的数据
            let idArr = [];
            this.dataList.forEach(item => {
              idArr.push(item.id);
            });
            data.image_id = idArr.join(",");
            materialDel(data).then(res => {
              if (res.code == 200) {
                this.$message.success("删除成功！！");
                this.reload();
              } else {
                this.$message.warning(res.msg);
              }
              console.log(res);
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消开启"
            });
          });
      }
    },
    choseFun(item) {
      this.choseImg = item.id;
      this.$emit("choseImgValue", item);
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getList();
    },
    getList() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page
      };
      materialList(data).then(res => {
        // dataList
        this.dataList = res.data.data;
        this.dataList.forEach(item => {
          item.createTime = time.setDate(item.create_time);
        });
        this.total = res.data.total;
        console.log(res);
      });
    },
    handleLogoSuccess(res, file) {
      if (res.code == 200) {
        this.getList();
        this.$message.success(res.msg);
      } else {
        this.$message.warning(res.msg);
      }
    },
    beforeLogoUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传Logo图片大小不能超过 2MB!");
      }
      return isLt2M;
    }
  }
};
</script>
<style lang="scss" scoped>
.shell {
  width: 100%;
}
.sourceContainer {
  width: 100%;
  height: auto;
  background: #fff;
  padding: 36px 30px 36px 40px;
  // -webkit-box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.05);
  // box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}
.sourceContainer .sourceTop {
  display: flex;
  justify-content: space-between;
}
.sourceContainer .sourceTop .desc .record {
  color: #979ba0;
  margin-top: 6px;
}
.sourceContainer .sourceTop .desc p {
  line-height: 20px;
  font-size: 14px;
  font-weight: 400;
}
.sourceContainer .sourceTop .btns {
  display: flex;
  .el-button {
    // padding: 6px 26px;
    width: 102px;
  }
  .el-button:first-child {
    margin-right: 10px;
  }
}
.sourceContainer .sourceList {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
}
.sourceContainer .sourceList li .imgBox {
  width: 160px;
  height: 160px;
  border: 1px solid #eeeef1;
  margin-top: 20px;
  margin-right: 26px;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  .noCheck {
    width: 160px;
    height: 160px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 32px;
    }
  }
}
.sourceContainer .sourceList .fileName {
  width: 170px;
  line-height: 20px;
  margin-top: 8px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  table-layout: fixed;
}
// 分頁
.sourceContainer .page {
  padding: 10px 0;
  text-align: right;
}
//
.null {
  color: #979ba0;
  text-align: center;
  line-height: 30px;
}
</style>
